import React, { useState, useEffect } from "react";
import { useTranslation } from "../../contexts/TranslationContext";
import "../../assets/css/UC/pagination.scss";
import { use } from "react";

export default function Pagination({ totalRecords, pageSize, pageIndex, changePageIndex, changePageSize }) {
    const { language } = useTranslation();
    const TotalPages = Math.ceil(totalRecords / pageSize);
    const [pageIndexSelect, setPageIndexSelect] = useState(pageIndex);
    const [selectedPageSize, setSelectedPageSize] = useState(pageSize);
    const [inputPage, setInputPage] = useState(pageIndex);
    const [isInputMode, setIsInputMode] = useState(false); // Toggle between display and input mode

    // useEffect(() => {
    //     // Trigger search when pageIndexSelect or selectedPageSize changes
    //     searchFunction(pageIndexSelect, selectedPageSize);
    // }, [pageIndexSelect, selectedPageSize, searchFunction]);

    // useEffect(() => {
    //     setPageIndexSelect(1);
    // }, [galleryType]);

    // useEffect(() => {
    //     // Reset inputPage when pageIndexSelect changes
    //     setInputPage(pageIndexSelect);
    // }, [pageIndexSelect]);

    // useEffect(() => {
    //     setPageIndexSelect(pageIndex);
    // }, [pageIndex]);

    // useEffect(() => {
    //     // Notify parent component of pagination changes
    //     if (changePagination)
    //         changePagination(pageIndexSelect);
    // }, [pageIndexSelect, changePagination]);

    useEffect(() => {
        setPageIndexSelect(pageIndex);
    }, [pageIndex]);

    useEffect(() => {
        setSelectedPageSize(pageSize);
    }, [pageSize]);

    const handlePageSizeChange = (e) => {
        const newPageSize = parseInt(e.target.value, 10);
        // setSelectedPageSize(newPageSize);
        // setPageIndexSelect(1); // Reset to the first page when page size changes

        changePageSize(newPageSize);
    };

    const handlePageInputChange = (e) => {
        const value = e.target.value;

        if (!value || isNaN(value)) {
            setInputPage('');
            return; // Ignore non-numeric input
        }

        // // check if value is within valid range
        // if (value > TotalPages) {
        //     setInputPage(TotalPages);
        //     return;
        // }

        // if (value < 1) {
        //     setInputPage(1);
        //     return;
        // }

        setInputPage(parseInt(value, 10)); // Update inputPage state
    };

    const handlePageInputSubmit = () => {

        if (inputPage > TotalPages) {
            return;
        }

        if (inputPage < 1) {
            return;
        }

        if (changePageIndex) {
            changePageIndex(inputPage);
        }
    };

    const handlePageInputBlur = () => {
        setIsInputMode(false); // Exit input mode when input loses focus
    };

    if (totalRecords === 0) {
        return (
            <></>
        );
    }

    return (
        <>
            <div className="total-records">
                <span>
                    {language.pagination?.showing || "Showing"} <b>{((pageIndexSelect - 1) * selectedPageSize + 1).toLocaleString()}</b> {language.pagination?.to || "to"} <b>{Math.min(pageIndexSelect * selectedPageSize, totalRecords).toLocaleString()}</b> {language.pagination?.of || "of"} <b>{totalRecords.toLocaleString()}</b> {language.pagination?.records || "records"}

                </span>
            </div>
            <div className="paginationAndPageSize">
                <ul className="pagination">
                    {/* First Page Icon */}
                    <li
                        key="firstPage"
                        className={pageIndexSelect === 1 ? "disabled" : ""}
                        onClick={() => {
                            if (changePageIndex)
                                changePageIndex(1);
                        }}
                    >
                        <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                    </li>

                    {/* Previous Page Icon */}
                    <li
                        key="prevPage"
                        className={pageIndexSelect === 1 ? "disabled" : ""}
                        onClick={() => {
                            if (pageIndexSelect === 1) return;
                            if (changePageIndex) changePageIndex(pageIndexSelect - 1);
                        }}
                    >
                        <i className="fa fa-angle-left" aria-hidden="true"></i>
                    </li>

                    {/* Pages Around Current Page */}
                    {pageIndexSelect > 1 && (
                        <li
                            key="prevPageNumber"
                            className="selectPage"
                            onClick={() => {
                                if (changePageIndex) changePageIndex(pageIndexSelect - 1);
                            }}
                        >
                            <span>{pageIndexSelect - 1}</span>
                        </li>
                    )}
                    <li key="currentPage" className="selectPage active">
                        <span>{pageIndexSelect}</span>
                    </li>
                    {pageIndexSelect < TotalPages && (
                        <li
                            key="nextPageNumber"
                            className="selectPage"
                            onClick={() => {
                                if (changePageIndex === TotalPages) return;
                                if (changePageIndex) changePageIndex(pageIndexSelect + 1)
                            }}
                        >
                            <span>{pageIndexSelect + 1}</span>
                        </li>
                    )}

                    {/* Page Input */}
                    <li className="pageInput">
                        {isInputMode ? (
                            <input
                                type="number"
                                min="1"
                                max={TotalPages}
                                value={inputPage}
                                onChange={handlePageInputChange}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") handlePageInputSubmit();
                                }}
                                onBlur={handlePageInputBlur} // Exit input mode on blur
                                autoFocus
                            />
                        ) : (
                            <span onClick={() => setIsInputMode(true)}>...</span> // Show "..." and enable input on click
                        )}
                    </li>

                    {/* Next Page Icon */}
                    <li
                        key="nextPage"
                        className={pageIndexSelect === TotalPages ? "disabled" : ""}
                        onClick={() => { if (changePageIndex) changePageIndex(Math.min(TotalPages, pageIndexSelect + 1)) }}
                    >
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                    </li>

                    {/* Last Page Icon */}
                    <li
                        key="lastPage"
                        className={pageIndexSelect === TotalPages ? "disabled" : ""}
                        onClick={() => { if (changePageIndex) changePageIndex(TotalPages) }}
                    >
                        <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                    </li>
                </ul>

                {/* Page Size Selector */}
                <div className="pagesize">
                    <select id="cboPageSize" value={selectedPageSize} onChange={handlePageSizeChange}>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                    </select>
                </div>
            </div>
        </>
    );
}